import React from "react";
import { TextInputComponent } from "../../../../common/components";
import "./filter-options-tenant.scss";
import { EmailFilterProps } from "./tenant-filter-helper";

const EmailFilter: React.FC<EmailFilterProps> = ({
  value,
  error,
  onChange,
  isEmailEnabled,
}) => {
  if (!isEmailEnabled) return null;

  return (
    <div className="tenant-filter-options-text-wrapper">
      <div className="filter-options-tenant-filters">
        <TextInputComponent
          type="text"
          fieldName="email"
          placeholder="Enter Email"
          optional={false}
          disabled={!isEmailEnabled}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default EmailFilter;